<!-- <div class="parent">
  <div class="fixDiv"></div>
  <div class="page"> -->

    <!-- <app-edite-user-details></app-edite-user-details> -->
<!-- start header  -->
<header>
    <app-head (newItemEvent)="addItem($event)" [titleModule]="'Handover'"></app-head>
</header>
<!-- end header  -->

<div class="row m-0">

    <!-- start sidebar  -->
    <app-sidebar class="col-lg-2" [showSide]="showSide" [titlepage]="'Handover'"></app-sidebar>
    <!-- end sidebar  -->

    <!-- start content page  -->
    <main class="p-4 col-lg-10 ">




    <div class="tabview-header-container">
      <p-breadcrumb class="max-w-full" [model]="items">
        <ng-template pTemplate="item" let-item>
          <a
            [routerLink]="item.routerLink"
            class="p-menuitem-link"
            routerLinkActive="text-primary font-semibold bread-active"
          >
            <span *ngIf="item.icon" [ngClass]="item.icon" class="mr-2"></span>
            <span>{{ item.label }}</span>
          </a>
        </ng-template>
      </p-breadcrumb>
    </div>

    <div class="card p-4 bg-white">
      <div class="  ">
        <div>
          <div class="d-flex justify-content-between align-items-center py-3">
            <h5 class="txt-color">Handover Details</h5>
          </div>

          <div class="border rounded px-2" style="border: #eef0f1 1px solid">
            <div class="row">
              <div class="col-lg px-3 pt-3">
                <div>
                  <img
                    class="icon"
                    src="/assets/images/handover/book.svg"
                    alt="bookicon"
                  />
                  <span class="title px-1">Problem ID</span>
                </div>
                <div class="ms-4">
                  <p>{{handover?.handover_Code}}</p>
                </div>
              </div>

              <div class="col-lg px-3 pt-3 horizontal-line1 flex-nowrap">
                <div>
                  <img
                    class="icon"
                    src="/assets/images/handover/UserIcon.svg"
                    alt="usericon"
                  />
                  <span class="title">Reported by</span>
                </div>

                <div class="ms-4">
                  <img
                    class="rounded-pill img-fluid my-1"
                    style="width: 40px; height: 40px"
                    [src]="handover?.worker_Profile_Image || '/assets/images/handover/Frame.svg'"
                    alt="frame"
                  />
                  <span class="ms-2">{{handover?.worker_Name}}</span>
                </div>
              </div>

              <div class="col-lg px-3 pt-3 horizontal-line1">
                <div>
                  <img
                    class="icon"
                    src="/assets/images/handover/dateIcon.svg"
                    alt="calendericon"
                  />
                  <span class="title">Date</span>
                </div>

                <div class="ms-4">
                  <p>{{handover?.date}}</p>
                </div>
              </div>

              <div class="col-lg px-3 pt-3 horizontal-line1">
                <div>
                  <img
                    class="icon"
                    src="/assets/images/handover/timeIcon.svg"
                    alt="ClockIcon"
                  />
                  <span class="title">Time</span>
                </div>

                <div class="ms-4">
                  <p>{{handover?.time}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="line my-5"
          style="width: 100%; height: 1px; background: #eef0f1"
        ></div>

        <div>
          <div class="pb-3">
            <h5 class="txt-color">Apartment Details</h5>
          </div>

          <div class="border rounded px-2" style="border: #eef0f1 1px solid">
            <div class="row card-line">
              <div class="col-lg px-3 pt-3">
                <div>
                  <img
                    class="icon"
                    src="/assets/images/handover/apartmentIcon.svg"
                    alt="apartmentIcon"
                  />
                  <span class="title px-1">Apartment</span>
                </div>
                <div class="ms-4">
                  <p>{{handover?.apartment_Name}}</p>
                </div>
              </div>

              <div class="col-lg px-3 pt-3 horizontal-line2">
                <div>
                  <img
                    class="icon"
                    src="/assets/images/handover/elevator.svg"
                    alt="elevator"
                  />
                  <span class="title">Floor</span>
                </div>

                <div class="ms-4">
                  <p>{{handover?.apartment_Floor}}</p>
                </div>
              </div>

              <div class="col-lg px-3 pt-3 horizontal-line2">
                <div>
                  <img
                    class="icon"
                    src="/assets/images/handover/ringIcon.svg"
                    alt="bellIcon"
                  />
                  <span class="title">Ringbell Name</span>
                </div>

                <div class="ms-4">
                  <p>{{handover?.apartment_RingBell}}</p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 px-3 pt-3">
                <div>
                  <img
                    class="icon"
                    src="/assets/images/handover/QRIcon.svg"
                    alt="QRcodeIcon"
                  />
                  <span class="title px-1">QR</span>
                </div>
                <div class="ms-4">
                  <p>{{handover?.apartment_QR}}</p>
                </div>
              </div>

              <div class="col-lg-8 px-3 pt-3 horizontal-line2">
                <div>
                  <img
                    class="icon"
                    src="/assets/images/handover/LocationIcon.svg"
                    alt="Locationicon"
                  />
                  <span class="title">Location</span>
                </div>

                <div class="ms-4">
                  <p>{{handover?.apartment_Location}}</p>
                </div>
              </div>
            </div>
          </div>

          <div
            class="line my-5"
            style="width: 100%; height: 1px; background: #eef0f1"
          ></div>

          <div>
            <div>
              <span style="color: #4a4a4a; font-size: 18px; font-weight: 500"
                >Photos</span
              >
            </div>

            <div>
              <div class="card flex justify-center mt-3">
                <p-accordion *ngIf="handover?.places?.length > 0">

                  <p-accordionTab *ngFor="let place of handover?.places">
                     <ng-template pTemplate="header">
                      <div>
                        <img class="me-2" [src]="getIconName(place?.place_Name)" alt="{{place?.place_Name}}">
                        <span style="color: #0A0C0F; font-size: 16px; font-weight: 500;">{{place?.place_Name}}</span>
                      </div>
                    </ng-template>

                    <div *ngIf="place?.questions">
                      <ul style="color: #0a0c0f; font-size: 16px">

                        <li *ngFor="let que of place.questions">
                          <p style="font-weight: 500">{{ que?.question }}</p>
                          <div>
                            <img
                              [src]="que.answer === 'yes'
                                      ? '/assets/images/handover/rightIcon.svg'
                                      : '/assets/images/handover/wrongIcon.svg'"
                              alt="Result Icon"
                              width="24"
                              height="24"
                              class="icon"
                            />
                            <span>{{ que.answer === 'yes' ? 'Yes' : 'No' }}</span>
                            <div *ngIf="que.answer !== 'yes'" class="mt-1 mb-3 row g-2">
                              <div *ngFor="let img of que?.images" class="col-md-3">
                                <img
                                  class="rounded w-100"
                                  [src]="img"
                                  alt="kitchen"
                                />
                              </div>
                            </div>

                          </div>

                          <div class="line my-3" style="width: 99%; height: 1px; background: #eef0f1"></div>
                        </li>

                      </ul>

                    </div>

                    <div style="color: #0a0c0f; font-size: 16px">
                      <div>
                        <h6 class="txt-color">Notes</h6>
                        <div
                          class="border rounded px-2"
                          style="border: #eef0f1 1px solid"
                        >
                          <div class="mt-3 ms-2">
                            <p>{{ place?.comment }}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="line my-3"
                      style="width: 99%; height: 1px; background: #eef0f1"
                    ></div>

                    <span style="color: #0a0c0f">Kitchen Photos</span>
                    <div class="mt-1 mb-3 row g-2">
                      <div *ngFor="let img of place?.place_Images" class="col-md-3">
                        <img
                          class="rounded w-100"
                          [src]="img"
                          alt="kitchen"
                        />
                      </div>

                    </div>
                  </p-accordionTab>


                  <!-- Custom Check -->
                  <!-- <p-accordionTab >

                     <ng-template pTemplate="header">
                      <div>
                        <img class="me-2" src="/assets/images/plusIcon.svg" alt="KitchenIcon">
                        <span style="color: #0A0C0F; font-size: 16px; font-weight: 500;">Custoom Check</span>
                      </div>
                    </ng-template>

                    <div style="color: #0a0c0f; font-size: 16px">
                      <div>
                        <h6 class="txt-color">Custom Check</h6>
                      </div>
                      <div
                        class="border rounded px-2"
                        style="border: #eef0f1 1px solid"
                      >
                        <div class="mt-3 ms-2">
                          <p>{{ handover?.places?.comment }}</p>
                        </div>
                      </div>
                    </div>

                    <div class="mt-1 mb-3 row g-2">
                      <div *ngFor="let img of handover?.places?.place_Images" class="col-md-3">
                        <img
                          class="rounded w-100"
                          [src]="img"
                          alt="kitchen"
                        />
                      </div>

                    </div>
                  </p-accordionTab> -->

                  <!------------------------------------------------------------------------------->
                </p-accordion>
              </div>
            </div>
          </div>

          <div class="d-flex gap-4 justify-content-end mt-4">
            <button class="btn-cancel rounded" (click)="handelCancle()">Cancel</button>
            <button class="btn-confirm rounded">
              <img class="icon" src="/assets/images/handover/Marks.svg" alt="" />
              Confirm as latest Version
            </button>
          </div>
        </div>
      </div>
    </div>




  </main>
</div>
